import React,{useState} from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiStar,FiChevronLeft,FiChevronRight}=FiIcons;

const SocialProof=()=> {
  const [currentTestimonial,setCurrentTestimonial]=useState(0);
  
  const testimonials=[
    {
      name: "Michael Long",
      age: "52, Marketing Director",
      image: "https://cdn1.sharemyimage.com/smi/2025/10/11/GenXDojoSiteManHeadshot1.jpeg",
      rating: 5,
      text: "Finally found AI training that doesn't talk down to me. Saved 8 hours per week on content creation.",
      result: "8 hours saved weekly",
      highlight: "Content Creation Mastery"
    },
    {
      name: "James Rodriguez",
      age: "47, Operations Manager",
      image: "https://cdn1.sharemyimage.com/smi/2025/10/11/GenXDojoSiteManHeadshot2.jpeg",
      rating: 5,
      text: "No fluff, just results. I'm automating reports that used to take me all day. Worth every penny.",
      result: "6-hour tasks now take 30 minutes",
      highlight: "Report Automation Expert"
    },
    {
      name: "Shanice Williams",
      age: "49, Small Business Owner",
      image: "https://cdn1.sharemyimage.com/smi/2025/10/11/GenXDojoSiteWomanHeadshot1.jpeg",
      rating: 5,
      text: "Perfect for busy professionals. Short lessons I can do during lunch. My business runs smoother now.",
      result: "30% increase in productivity",
      highlight: "Business Efficiency Leader"
    }
  ];

  const nextTestimonial=()=> {
    setCurrentTestimonial((prev)=> (prev + 1) % testimonials.length);
  };

  const prevTestimonial=()=> {
    setCurrentTestimonial((prev)=> (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section id="testimonials" className="py-20 bg-gradient-to-br from-slate-50 to-blue-50 dark:from-slate-800 dark:to-slate-700">
      <div className="max-w-screen-2xl mx-auto px-6 sm:px-8 lg:px-12 xl:px-16">
        <motion.div
          initial={{opacity: 0,y: 30}}
          whileInView={{opacity: 1,y: 0}}
          transition={{duration: 0.6}}
          viewport={{once: true}}
          className="text-center mb-16"
        >
          <h2 className="text-5xl md:text-6xl font-bold text-slate-800 dark:text-white mb-6">
            Real Results from <span className="text-amber-500">Real People</span>
          </h2>
          <p className="text-2xl md:text-3xl text-slate-600 dark:text-slate-300 font-medium">
            See how GenXDojo helped professionals like you master AI
          </p>
        </motion.div>

        <div className="relative">
          <motion.div
            key={currentTestimonial}
            initial={{opacity: 0,x: 50}}
            animate={{opacity: 1,x: 0}}
            exit={{opacity: 0,x: -50}}
            transition={{duration: 0.5}}
            className="bg-white dark:bg-slate-900 p-10 rounded-3xl shadow-2xl border-4 border-amber-200 dark:border-amber-600"
          >
            <div className="flex flex-col md:flex-row items-start md:items-center mb-8">
              <img
                src={testimonials[currentTestimonial].image}
                alt={testimonials[currentTestimonial].name}
                className="w-24 h-24 rounded-full mr-6 mb-4 md:mb-0 border-4 border-amber-300"
              />
              <div className="flex-1">
                <h4 className="font-bold text-2xl text-slate-800 dark:text-white mb-2">
                  {testimonials[currentTestimonial].name}
                </h4>
                <p className="text-xl text-slate-600 dark:text-slate-400 mb-3">
                  {testimonials[currentTestimonial].age}
                </p>
                <div className="bg-amber-100 dark:bg-amber-900/30 text-amber-800 dark:text-amber-400 px-4 py-2 rounded-full text-lg font-bold inline-block mb-3">
                  {testimonials[currentTestimonial].highlight}
                </div>
                <div className="flex mb-2">
                  {[...Array(testimonials[currentTestimonial].rating)].map((_,i)=> (
                    <SafeIcon key={i} icon={FiStar} className="w-6 h-6 text-yellow-400 fill-current" />
                  ))}
                </div>
              </div>
            </div>

            <blockquote className="text-2xl md:text-3xl text-slate-700 dark:text-slate-200 mb-8 italic font-medium leading-relaxed">
              "{testimonials[currentTestimonial].text}"
            </blockquote>

            <div className="bg-gradient-to-r from-green-100 to-green-200 dark:from-green-900/30 dark:to-green-800/30 p-6 rounded-2xl border-4 border-green-300 dark:border-green-600">
              <p className="text-green-800 dark:text-green-400 font-bold text-2xl text-center">
                <span className="text-3xl">🎯</span> Result: {testimonials[currentTestimonial].result}
              </p>
            </div>
          </motion.div>

          <div className="flex justify-center items-center mt-12 space-x-6">
            <button
              onClick={prevTestimonial}
              className="p-4 rounded-full bg-white dark:bg-slate-700 shadow-xl hover:shadow-2xl transition-shadow border-4 border-amber-200 dark:border-amber-600"
            >
              <SafeIcon icon={FiChevronLeft} className="w-8 h-8 text-slate-600 dark:text-slate-300" />
            </button>

            <div className="flex space-x-3">
              {testimonials.map((_,index)=> (
                <button
                  key={index}
                  onClick={()=> setCurrentTestimonial(index)}
                  className={`w-5 h-5 rounded-full transition-colors ${
                    index===currentTestimonial 
                      ? 'bg-amber-500 border-4 border-amber-300' 
                      : 'bg-slate-300 dark:bg-slate-600 border-2 border-slate-400'
                  }`}
                />
              ))}
            </div>

            <button
              onClick={nextTestimonial}
              className="p-4 rounded-full bg-white dark:bg-slate-700 shadow-xl hover:shadow-2xl transition-shadow border-4 border-amber-200 dark:border-amber-600"
            >
              <SafeIcon icon={FiChevronRight} className="w-8 h-8 text-slate-600 dark:text-slate-300" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialProof;